import { render, staticRenderFns } from "./ficha-turno-2.vue?vue&type=template&id=442e7ebf&scoped=true&"
import script from "./ficha-turno-2.vue?vue&type=script&lang=js&"
export * from "./ficha-turno-2.vue?vue&type=script&lang=js&"
import style0 from "./ficha-turno-2.vue?vue&type=style&index=0&id=442e7ebf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442e7ebf",
  null
  
)

export default component.exports